import { Button } from "components/Button";
import { Input } from "components/Input";
import { AliRecord } from "services/ALIRecord";

export function AdditionalInfoSection({
  recordRequest,
  record,
  handleChange,
  showAdditionalInfo,
  setShowAdditionalInfo,
}: {
  recordRequest: AliRecord;
  record: AliRecord;
  handleChange: (e: any) => void;
  showAdditionalInfo: boolean;
  setShowAdditionalInfo: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <>
      <div style={{ padding: "0 20px" }}>
        <div style={{ marginBottom: "20px", textAlign: "center" }}>
          {showAdditionalInfo && (
            <h3 style={{ marginBottom: "10px" }}>Additional Information</h3>
          )}
        </div>
        <div
          style={{
            overflow: "hidden",
            transition:
              "max-height 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s",
            maxHeight: showAdditionalInfo ? 1000 : 0,
            opacity: showAdditionalInfo ? 1 : 0,
          }}
        >
          {showAdditionalInfo && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "100px",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Input
                  name="Exchange"
                  label="Exchange"
                  value={recordRequest.Exchange ?? record.Exchange ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={4}
                />
                <Input
                  name="OrderNumber"
                  label="Order Number"
                  value={recordRequest.OrderNumber ?? record.OrderNumber ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={10}
                />
                <Input
                  name="lecLAT"
                  label="Latitude"
                  value={recordRequest.lecLAT ?? record.lecLAT ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={9}
                />
                <Input
                  name="lecLON"
                  label="Longitude"
                  value={recordRequest.lecLON ?? record.lecLON ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={9}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <Input
                  name="lecELV"
                  label="Elevation"
                  value={recordRequest.lecELV ?? record.lecELV ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={5}
                />
                <Input
                  name="NENAReserved"
                  label="NENA Reserved"
                  value={
                    recordRequest.NENAReserved ?? record.NENAReserved ?? ""
                  }
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={81}
                />
                <Input
                  name="DataProviderID"
                  label="Data Provider ID"
                  value={
                    recordRequest.DataProviderID ?? record.DataProviderID ?? ""
                  }
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={5}
                />
                <Input
                  name="Reserved2"
                  label="Reserved 2"
                  value={recordRequest.Reserved2 ?? record.Reserved2 ?? ""}
                  onChange={handleChange}
                  scale="s"
                  labelSize="s"
                  max={31}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: showAdditionalInfo ? "20px" : "0",
        }}
      >
        <Button
          variant="outline"
          kind="brand"
          onClick={() => {
            setShowAdditionalInfo((prev: boolean) => {
              const next = !prev;
              if (!prev) {
                setTimeout(() => {
                  const exchangeInput = document.querySelector(
                    'calcite-input[name="Exchange"]',
                  ) as any | null;
                  exchangeInput?.setFocus();
                }, 100);
              }
              return next;
            });
          }}
          type="button"
        >
          {showAdditionalInfo ? "Hide" : "Show"} Additional Information
        </Button>
      </div>
    </>
  );
}
